/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewStudentAssignmentOverviewEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('NEW_STUDENT_ASSIGNMENT_OVERVIEW_ENABLED'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class NewStudentAssignmentOverviewEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewStudentAssignmentOverviewEnabledSettingParser.decode(input).map(res => new NewStudentAssignmentOverviewEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return NewStudentAssignmentOverviewEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewStudentAssignmentOverviewEnabledSettingParser.encode(data);
    }
    static schema() {
        return NewStudentAssignmentOverviewEnabledSettingParser.schema();
    }
}
